import { render, staticRenderFns } from "./txtRequirements.vue?vue&type=template&id=4d655f2e&scoped=true"
import script from "./txtRequirements.vue?vue&type=script&lang=js"
export * from "./txtRequirements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d655f2e",
  null
  
)

export default component.exports